import { render, staticRenderFns } from "./NewUserLogin.vue?vue&type=template&id=5a2e5b1e&scoped=true"
import script from "./NewUserLogin.vue?vue&type=script&lang=js"
export * from "./NewUserLogin.vue?vue&type=script&lang=js"
import style0 from "./NewUserLogin.vue?vue&type=style&index=0&id=5a2e5b1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2e5b1e",
  null
  
)

export default component.exports